import { Injectable, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIService } from './ui.service';

@Injectable({ providedIn: 'root' })
export class FormValidationService {
  private translateService = inject(TranslateService);
  private uiService = inject(UIService);

  constructor() {
    this.translateService.onLangChange.subscribe(() => {
      this.uiService.freeze();
      const inputs =
        document.querySelectorAll<HTMLInputElement>('input.ds-input');

      inputs.forEach((input) => {
        // принудительно сбрасываем и возвращаем фокус
        input.focus();
        input.blur();
      });
      this.uiService.unFreeze();
    });
  }

  validateFormControl(control: FormControl, isSubmitted: boolean): boolean {
    return (
      (control.dirty && control.invalid) || (isSubmitted && control.invalid)
    );
  }

  isInvalid(control: FormControl, isSubmitted: boolean) {
    return (
      (isSubmitted && control.invalid && control.dirty) ||
      (isSubmitted && control.invalid)
    );
  }

  isInValidFormControl(
    control: FormControl,
    isSubmitted: boolean,
    isfocused: boolean | undefined = undefined
  ): boolean {
    const result =
      isfocused === undefined
        ? (control.dirty && control.invalid) || (isSubmitted && control.invalid)
        : (!isfocused && control.dirty && control.invalid) ||
          (isSubmitted && control.invalid);

    return result;
  }
  invalidFeedback(
    domelement: HTMLElement,
    form: FormGroup,
    translatePrefix: string,
    attribute: string = 'formcontrolname'
  ) {
    const el = <HTMLElement>domelement;
    //    const isfocused = !!el?.classList?.contains('is-focused');
    const name = el.getAttribute(attribute) ?? '';
    const control = <FormControl>form.get(name);

    const result = this.selectError(
      control,
      `${translatePrefix}.FC.${name}.ERR`
    );
    return result ? this.translateService.instant(result) : '';
  }

  private selectError(control: FormControl, error: string): string {
    const errorsArray: string[] = [];
    //console.log(control.errors);
    if (!!control.errors && 'required' in control.errors) {
      //output = 'INT.REQUIRED.FIELD.ERR';
      errorsArray.push(`${error}.REQUIRED`);
      //return REQUIRED_ERR.toUpperCase();
    }
    if (!!control.errors && 'pattern' in control.errors) {
      errorsArray.push(`${error}.PATTERN`);
    }

    if (!!control.errors && 'checksum' in control.errors) {
      errorsArray.push(`${error}.CHECKSUM`);
    }

    if (!!control.errors && 'mimetype' in control.errors) {
      errorsArray.push(`${error}.MIMETYPE`);
    }

    if (!!control.errors && 'maxsize' in control.errors) {
      errorsArray.push(`${error}.MAXSIZE`);
    }

    if (!!control.errors && 'minlength' in control.errors) {
      errorsArray.push(`${error}.MINLENGTH`);
    }

    if (!!control.errors && 'maxlength' in control.errors) {
      errorsArray.push(`${error}.MAXLENGTH`);
    }

    if (!!control.errors && 'minamount' in control.errors) {
      errorsArray.push(`${error}.MINAMOUNT`);
    }

    if (!!control.errors && 'nolength' in control.errors) {
      errorsArray.push(`${error}.NOLENGTH`);
    }
    if (!!control.errors && 'nolowercase' in control.errors) {
      errorsArray.push(`${error}.NOLOWERCASE`);
    }
    if (!!control.errors && 'nouppercase' in control.errors) {
      errorsArray.push(`${error}.NOUPPERCASE`);
    }
    if (!!control.errors && 'nonumbers' in control.errors) {
      errorsArray.push(`${error}.NONUMBERS`);
    }
    if (!!control.errors && 'nospecs' in control.errors) {
      errorsArray.push(`${error}.NOSPECS`);
    }

    if (!!control.errors && 'insufficientFunds' in control.errors) {
      errorsArray.push(`${error}.INSUFFICIENTFUNDS`);
    }

    if (!!control.errors && 'min' in control.errors) {
      errorsArray.push(`${error}.MIN`);
    }

    if (!!control.errors && 'max' in control.errors) {
      errorsArray.push(`${error}.max`);
    }

    return errorsArray[0]?.toUpperCase() ?? '';
  }
}
